/**
 * Feature switch for the plan-change rules decided on 2026-10-15, which the
 * staging backend applies since then (PlanChangeService) and production's
 * doesn't have yet. `REACT_APP_USE_PLAN_DOWNGRADES=true` turns them on:
 *
 * - what choosing a plan does (planChanges.js): an upgrade now, with the
 *   difference charged today; a downgrade, or monthly → annual on the same
 *   packet, when the contract ends (`pendingPlanChange`, "Keep my current
 *   plan" through POST /Payment/cancel-plan-change); a smaller plan the
 *   organization doesn't fit is refused until it archives what it doesn't need
 *   (GET /Workspaces/getPlanUsage, planUsage.js);
 * - archiving workspaces and projects (components/Archive/archiveApi.js), which keeps them, and
 *   everything in them, out of the plan's limits.
 *
 * Off, or missing, a plan changes now, as the backend before the rules did it:
 * the difference is prorated onto the next invoice. Against a backend that has
 * the rules, that copy is wrong: the server schedules a downgrade for the end
 * of the contract whatever the page asks for.
 */
export const isPlanDowngradesEnabled = () =>
   String(process.env.REACT_APP_USE_PLAN_DOWNGRADES).toLowerCase() === "true";
